export default __webpack_public_path__ + "static/media/by.b8a24221.jpg";